// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"710":"d2602ede","719":"59354e7d"}[chunkId] + ".css";
};